import axios from 'axios'
// import APP_ENVIRONMENT from '../environment/environment';

// Previo a realizar la solicitud
axios.interceptors.request.use(
  (config) => {
    const { baseURL, url, method } = config
    console.info(`AXIOS: Requesting ${method} - ${baseURL}${url}`)
    return config
  },
  (error) => {
    console.error(`AXIOS: REQUEST ERROR`)
    return Promise.reject(error)
  }
)

// Respuestas
axios.interceptors.response.use(
  (response) => {
    const { baseURL, url, method } = response.config
    const { status } = response
    console.info(`AXIOS: Request ${method} - ${baseURL}${url} OK (${status})`)
    return response
  },
  (error) => {
    if (error.response) {
      const { status, statusText, data, config } = error.response
      const { baseURL, url } = config
      console.error(`AXIOS: ERROR ${status} - ${statusText} - ${baseURL}${url}`)
      return Promise.reject({ status, data, statusText })
    } else {
      console.error(`AXIOS: ERROR ${error}`)
      return Promise.reject(error)
    }
  }
)

export default axios
